import { ItemDependencyManager } from "@/types/productTypes";
import { produce } from "immer";

import fetchDb from "../utils/customRequestFunction";

import { AdminSliceCreator, AdminStoreState } from "./useAdminStore";

import { Configuration } from "@/types/productTypes";

export interface ConfigStoreState {
   configurations: Configuration[];
   details: { name: string; lastName: string; email: string; phone: string };
   totalPrice: number;
   updateOptionDependencies: (
      productId: number,
      stageId: number,
      optionId: number,
      dependencies: ItemDependencyManager[]
   ) => Promise<void>;
   applyConfiguration: (watchedValues: Record<string, any>) => void;
   // handleSubmit: (language: string) => Promise<void>;
   isUpdating: boolean;
   lastError: string | null;
   refreshConfig: (productId: number, stageId: number) => Promise<void>;
}

export const createConfigSlice: AdminSliceCreator<ConfigStoreState> = (
   set
) => ({
   configurations: [],
   details: {
      name: "",
      lastName: "",
      email: "",
      phone: "",
   },
   totalPrice: 0,
   isUpdating: false,
   lastError: null,

   updateOptionDependencies: async (
      productId,
      stageId,
      optionId,
      dependencies
   ) => {
      set(
         produce((state: AdminStoreState) => ({
            ...state,
            isUpdating: true,
            lastError: null,
         }))
      );

      try {
         set(
            produce((state: AdminStoreState) => {
               const config = state.configurations.find(
                  (c) =>
                     c.productId === productId &&
                     c.stageId === stageId &&
                     c.optionId === optionId
               );
               if (config) {
                  config.dependencies = dependencies;
               } else {
                  state.configurations.push({
                     productId,
                     stageId,
                     optionId,
                     dependencies,
                  });
               }
            })
         );

         await fetchDb.post("/api/config/updateDependencies", {
            productId,
            stageId,
            optionId,
            dependencies,
         });
      } catch (error) {
         console.error("Error updating dependencies:", error);
         set((state) => ({
            ...state,
            lastError: error instanceof Error ? error.message : "Unknown error",
         }));
      } finally {
         set((state) => ({ ...state, isUpdating: false }));
      }
   },

   applyConfiguration: (watchedValues) => {
      set(
         produce((state: AdminStoreState) => {
            state.configurations.forEach((config) => {
               const watched = watchedValues[config.optionId.toString()];
               if (watched && "selectedItem" in watched) {
                  config.selectedItem = watched.selectedItem;
               }
            });
         })
      );
   },

   refreshConfig: async (productId: number, stageId: number) => {
      try {
         const response = await fetchDb.get(
            `/api/config/${productId}/${stageId}`
         );

         set(
            produce((state: AdminStoreState) => {
               state.configurations = state.configurations.filter(
                  (config) =>
                     config.productId !== productId ||
                     config.stageId !== stageId
               );
               state.configurations.push(...response.configurations);
            })
         );
      } catch (error) {
         console.error("Error refreshing configuration:", error);
         set((state) => ({
            ...state,
            lastError: error instanceof Error ? error.message : "Unknown error",
         }));
      }
   },

   // handleSubmit: async (language: string) => {
   //     set((state) => ({ ...state, isUpdating: true, lastError: null }));

   //     try {
   //         const state = get();
   //         const pickedRows = state.configurations.map((config) => ({
   //             productId: config.productId,
   //             stageId: config.stageId,
   //             optionId: config.optionId,
   //             selectedItem: config.selectedItem,
   //             dependencies: config.dependencies,
   //         }));

   //         const response = await fetch(
   //             "https://config-backend.vercel.app/sendEmail",
   //             {
   //                 method: "POST",
   //                 headers: { "Content-Type": "application/json" },
   //                 body: JSON.stringify({
   //                     productName: "Carport 5000",
   //                     totalPrice: state.totalPrice,
   //                     options: pickedRows,
   //                     details: state.details,
   //                     language: language,
   //                 }),
   //             }
   //         );

   //         if (!response.ok) {
   //             throw new Error(await response.text());
   //         }

   //         const blob = await response.blob();
   //         const fileURL = URL.createObjectURL(blob);
   //         const link = document.createElement("a");
   //         link.href = fileURL;
   //         link.download = "Order.pdf";
   //         document.body.appendChild(link);
   //         link.click();
   //         document.body.removeChild(link);
   //     } catch (error) {
   //         console.error("Error in handleSubmit:", error);
   //         set((state) => ({
   //             ...state,
   //             lastError:
   //                 error instanceof Error ? error.message : "Unknown error",
   //         }));
   //     } finally {
   //         set((state) => ({ ...state, isUpdating: false }));
   //     }
   // },
});
